import "./Header.css";
import { Link } from "react-router-dom";
import { app } from "../../functions/firebaseInit";
import { initializeApp } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import Logo from "../Logo";

export default function Header(props) {

    const fbApp = initializeApp(app);
    const auth = getAuth(fbApp);

    return <header>
        <Logo />
        <div id="header-links">
            <Link reloadDocument to={"/"}>Build</Link>
            <Link reloadDocument to={"/browse"}>Browse</Link>
            {auth.currentUser?.uid ?
                <>
                    <Link reloadDocument to={`/profile/${auth.currentUser.uid}`}>Profile</Link>
                    <Link reloadDocument onClick={() => signOut(auth)}>
                        Sign Out
                    </Link>
                </>
                : <Link to="/signin">Sign In</Link>}
        </div>
    </header>
}